import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const HEADER_TITLE_FONT_SIZE_IN_PIXELS = 26
const SEARCH_BUTTON_SIZE_IN_PIXELS = 44
const BACK_BUTTON_SIZE_IN_PIXELS = 40
const CLEAR_BUTTON_SIZE_IN_PIXELS = 22

const useStyles = makeStyles(theme => ({
	collapsedHeader: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: "0.625rem 1.25rem 0.875rem",
		gap: 12,
		width: "100%"
	},
	expandedHeader: {
		display: "flex",
		alignItems: "center",
		padding: "0.375rem 0.875rem 0.875rem",
		gap: 10,
		width: "100%"
	},
	headerTitle: {
		fontSize: HEADER_TITLE_FONT_SIZE_IN_PIXELS,
		fontWeight: 700,
		letterSpacing: "-0.01em",
		color: colors.gray[800]
	},
	titleGroup: {
		display: "flex",
		alignItems: "center",
		gap: 10
	},
	instanceChipAlignment: {
		marginTop: "0.25rem"
	},
	searchButton: {
		width: SEARCH_BUTTON_SIZE_IN_PIXELS,
		height: SEARCH_BUTTON_SIZE_IN_PIXELS,
		borderRadius: "62.4375rem",
		border: `0.0625rem solid ${colors.gray[200]}`,
		backgroundColor: colors.gray[0],
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: 0,
		"&:hover": {
			backgroundColor: colors.gray[0]
		}
	},
	backButton: {
		width: BACK_BUTTON_SIZE_IN_PIXELS,
		height: BACK_BUTTON_SIZE_IN_PIXELS,
		borderRadius: "50%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: 0,
		"&:hover": {
			backgroundColor: "transparent"
		}
	},
	searchInputWrapper: {
		flex: 1,
		display: "flex",
		alignItems: "center",
		gap: 10,
		backgroundColor: colors.gray[50],
		borderRadius: 14,
		padding: "0.625rem 0.875rem"
	},
	searchInput: {
		flex: 1,
		border: "none",
		outline: "none",
		backgroundColor: "transparent",
		fontSize: theme.typography.pxToRem(16),
		color: colors.gray[800],
		"&::placeholder": {
			color: colors.gray[500]
		}
	},
	clearButton: {
		width: CLEAR_BUTTON_SIZE_IN_PIXELS,
		height: CLEAR_BUTTON_SIZE_IN_PIXELS,
		borderRadius: "50%",
		backgroundColor: colors.gray[500],
		border: "none",
		color: colors.gray[0],
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: 0,
		cursor: "pointer",
		"&:hover": {
			backgroundColor: colors.gray[600]
		}
	}
}))

export default useStyles
